var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"section-header josh-js",class:{'section-header--invert': _vm.invert},attrs:{"data-josh-anim-name":"fadeIn","data-josh-duration":"1500ms","data-josh-anim-delay":"0.3s"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }